import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { Project } from '../../data/mockProjects';

interface RecentProjectsProps {
  projects: Project[];
}

export const RecentProjects: React.FC<RecentProjectsProps> = ({ projects }) => {
  const navigate = useNavigate();
  
  const getStatusVariant = (status: Project['status']) => {
    const variants: Record<Project['status'], 'success' | 'warning' | 'danger' | 'info' | 'default'> = {
      'Declaración': 'info',
      'Evaluación': 'warning',
      'Protección': 'default',
      'Negociación': 'warning',
      'Licenciado': 'success',
    };
    return variants[status];
  };
  
  return (
    <Card>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Proyectos Recientes
      </h3>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
                Título
              </th>
              <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
                Estado
              </th>
              <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
                Inventor
              </th>
              <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
                Fecha
              </th>
            </tr>
          </thead>
          <tbody>
            {projects.slice(0, 5).map((project) => (
              <tr
                key={project.id}
                className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors"
                onClick={() => navigate(`/proyectos/${project.id}`)}
              >
                <td className="py-3 px-4">
                  <p className="text-sm font-medium text-gray-900">
                    {project.title}
                  </p>
                </td>
                <td className="py-3 px-4">
                  <Badge variant={getStatusVariant(project.status)}>
                    {project.status}
                  </Badge>
                </td>
                <td className="py-3 px-4">
                  <p className="text-sm text-gray-600">{project.leadInventor}</p>
                </td>
                <td className="py-3 px-4">
                  <p className="text-sm text-gray-600">
                    {format(new Date(project.createdDate), 'dd MMM yyyy', { locale: es })}
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
